module.exports = __webpack_public_path__ + "img/boleto-simbolo.8995bcfb.jpg";